<template>
    <template v-if = "isActive">
        <div class="fullSizeImageBackground" @click="$emit('update:isActive', false)"></div>
            <div class = 'fullSizeImage'>
                <img :src = "src" class = "img">
                <div style = "margin:20px;z-index:1001;position:absolute; pointer-events:all">
                    <TButton
                        @click="$emit('update:isActive', false)"
                        buttonClass="back"
                        :color="'light-color'"
                        :icon="'pi pi-times'"
                        :rounded="true"
                    ></TButton>
                </div>
            </div>
        
    </template>
</template>


<script>
    import TButton from '../../../common/components/buttons/TButton.vue'
    export default{
        components:{TButton},
        props:{
            isActive:Boolean,
            src:String,
        },
        emits: ['update:isActive'],
    }
    
</script>

<style lang="scss">
    .fullSizeImage{
        top: 0;
        left: 0;
        z-index: 1000;
        width: 100vw;
        height: 100vh;
        position: fixed;
        pointer-events: none;
        
        .img{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            max-width: 100%;
            max-height: 100%;
            z-index: 1000;
            pointer-events: all; 
        }
    }
    .fullSizeImageBackground{
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,0.3);
        z-index: 1000;
        position: fixed;

        
    }

</style>